import { EntityType } from 'models/approval';

export const showPreview = (entityType: EntityType) => {
  return entityType === 'Page' || entityType === 'BlogArticle';
};
